import { supabase } from './supabase'

export const profileService = {
  async getProfile(userId) {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('user_id', userId)
      .single()

    if (error) throw new Error('Perfil não encontrado')
    return data
  },

  async getSellers() {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .order('name')

    if (error) throw new Error('Erro ao buscar sellers')
    return data
  }
}
